import script from "./CreateUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateUserForm.vue?vue&type=style&index=0&id=ee7ff420&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee7ff420"]])

export default __exports__